import { formValueSelector } from "redux-form";
import { useSelector } from "react-redux";

export const useReduxFormValues = (formName, fields = [""]) => {
    const state = useSelector(state => state);

    return formValueSelector(formName)(state, ...fields, "");
};
